var chunkMapping = {
	"0": [
		4657
	],
	"76": [
		5063
	],
	"152": [
		5139
	],
	"153": [
		5140
	],
	"156": [
		5143
	],
	"157": [
		5144
	],
	"158": [
		5145
	],
	"159": [
		5146
	],
	"160": [
		5147
	],
	"161": [
		5148
	],
	"162": [
		5149
	],
	"163": [
		5150
	],
	"164": [
		5151
	],
	"165": [
		5152
	],
	"166": [
		5153
	],
	"167": [
		5154
	],
	"168": [
		5155
	],
	"169": [
		5156
	],
	"170": [
		5157
	],
	"171": [
		5158
	],
	"172": [
		5159
	]
};
var idToExternalAndNameMapping = {
	"4657": [
		"default",
		"./Containers",
		3808
	],
	"5063": [
		"default",
		"./OrderlessInvoices",
		3808
	],
	"5139": [
		"default",
		"./AsyncEventTracker",
		3808
	],
	"5140": [
		"default",
		"./HostWrapper",
		3808
	],
	"5143": [
		"default",
		"./CheckoutV3",
		3808
	],
	"5144": [
		"default",
		"./CheckoutConfirmation",
		3808
	],
	"5145": [
		"default",
		"./ContactCreditCards",
		3808
	],
	"5146": [
		"default",
		"./AuditDialog",
		3808
	],
	"5147": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3808
	],
	"5148": [
		"default",
		"./InvoiceDialog",
		3808
	],
	"5149": [
		"default",
		"./PaymentDueModal",
		3808
	],
	"5150": [
		"default",
		"./PaymentModal",
		3808
	],
	"5151": [
		"default",
		"./PaymentHistory",
		3808
	],
	"5152": [
		"default",
		"./PaymentConfigurations",
		3808
	],
	"5153": [
		"default",
		"./PaymentPreferences",
		3808
	],
	"5154": [
		"default",
		"./ManagePaymentProcessing",
		3808
	],
	"5155": [
		"default",
		"./MobilePaymentsWrapper",
		3808
	],
	"5156": [
		"default",
		"./Challenge",
		3808
	],
	"5157": [
		"default",
		"./ManagePaymentMethods",
		3808
	],
	"5158": [
		"default",
		"./LightspeedReports",
		3808
	],
	"5159": [
		"default",
		"./ShippingPromotionsListContainer",
		3808
	]
};
var idToRemoteMap = {
	"4657": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3808
		}
	],
	"5063": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3808
		}
	],
	"5139": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3808
		}
	],
	"5140": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3808
		}
	],
	"5143": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3808
		}
	],
	"5144": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3808
		}
	],
	"5145": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3808
		}
	],
	"5146": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3808
		}
	],
	"5147": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3808
		}
	],
	"5148": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3808
		}
	],
	"5149": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3808
		}
	],
	"5150": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3808
		}
	],
	"5151": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3808
		}
	],
	"5152": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3808
		}
	],
	"5153": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3808
		}
	],
	"5154": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3808
		}
	],
	"5155": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3808
		}
	],
	"5156": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3808
		}
	],
	"5157": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3808
		}
	],
	"5158": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3808
		}
	],
	"5159": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3808
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}